const useMatador = {
    isEnabled() {
        return typeof window.matador !== 'undefined';
    },

    toggleSidepanel() {
        if (!this.isEnabled()) {
            return;
        }

        window.matador.toggleSidepanel();
    },

    openEmail(email, firstName, lastName) {
        if (!this.isEnabled()) {
            return;
        }

        window.matador.openConversation({
            email,
            name: firstName,
            lastName,
        });
    },

    openPhone(phone, firstName, lastName) {
        if (!this.isEnabled()) {
            return;
        }

        window.matador.openConversation({
            phoneNumber: phone,
            name: firstName,
            lastName,
        });
    },
};

export default useMatador;
